import React from "react";
import { ICellRendererParams } from "@ag-grid-community/core";
import { TwoLineGridCell } from "fe-shared-transactions/src/components/TransactionsDataGrid/renderers";
import { GridInventoryAdjustment } from "../../../types/inventoryAdjustments";

interface Props extends ICellRendererParams {
  data: GridInventoryAdjustment;
}

const ParticipantRenderer = ({ data }: Props) => {
  return (
    <TwoLineGridCell
      firstLineData={data?.participantDisplayName}
      secondLineData={data?.participantRegNumber}
    />
  );
};

export default ParticipantRenderer;
